<template>
  <v-layout row>
    <v-flex xs12>
      <v-card>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card-title class="project">
            <span class="headline white--text">Upload CSV file</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12>
                  <input type="file" @change="handleFileUpload" accept=".csv" />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="cancel">Close</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapGetters } from "vuex";
import Papa from "papaparse";
export default {
  props: {
    project_id: Number,
  },
  data: () => ({
    valid: true,
    dialog: false,
    timeout: 4000,
    allowedTaskRules: [(v) => !!v || "This field is required"],
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
  },

  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const columnData = [
          "question",
          "question_bangla",
          "question_variable",
          "required_optional",
          "multiple_answer",
          "ui_category_id",
        ];
        const reader = new FileReader();
        reader.onload = () => {
          const fileContent = reader.result;
          Papa.parse(fileContent, {
            header: true, // If the first row contains headers
            complete: (result) => {
              const data = result.data; // Parsed data
              // console.log("Parsed data:", data[0]);
              const areAllElementsInArray2 = columnData.every((element) =>
                Object.keys(data[0]).includes(element)
              );
              if (!areAllElementsInArray2) {
                alert("Column not match. Please provide data as like sample csv file");
              }
              // console.log("Parsed data:", data);
              this.$emit("importQuestion", data);
              this.dialog = false;
            },
          });
        };
        reader.readAsText(file);
      }
    },
    cancel() {
      // console.log(this.token);
      this.$emit("importQuestion", false);
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
  },
};
</script>
